import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';
import EmptyComponent from './EmptyComponent';
import FilterComponent from './FilterComponent';
import './style.css';
import { renderSortIcons } from './sortConfig';

export const Filters = {
  PAGE: 1,
  OBJ: {
      order_By: '',
      page: 1,
      pageSize: 10,
      direction: 'DESC',
      search: '',
      adminName: 'admin',
      categoryId: '',
      created_at: 'created_at',
      status: '',
      payment_status: '',
      payment_type: '',
      product_unit: '',
      base_unit:''
  }
}

const ReactDataTable = (props) => {
  const {
    columns,
    items,
    isShowSearch,
    defaultLimit = Filters.OBJ.page,
    onChange,
    totalRows,
    paginationRowsPerPageOptions = [10, 15, 25, 50, 100],
    isLoading,
    navigateUrl,
    subHeader = true,
    ...rest
  } = props;
  const [perPage, setPerPages] = useState(defaultLimit);
  const [pageSize, setPageSize] = useState(Filters.OBJ.pageSize);
  const [searchText, setSearchText] = useState('');
  const [direction, setDirection] = useState(Filters.OBJ.direction);
  const [orderBy, setOrderBy] = useState(Filters.OBJ.order_By);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();

  const tableColumns = useMemo(() => columns, [navigateUrl]);

  useEffect(() => {
    onChangeDidMount(currentPage);
  }, [currentPage, perPage, searchText, navigateUrl, direction, orderBy]);

  const handleSearch = (searchText) => {
    handlePageChange(1);
    setSearchText(searchText);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <>{isShowSearch ? '' : <FilterComponent handleSearch={handleSearch} />}</>
    );
  }, []);

  const onChangeDidMount = () => {
    const filters = {
      page: currentPage,
      perpage: pageSize,
      sortBy: orderBy,
      direction: direction.toUpperCase(),
      search:
        searchText === ''
          ? searchText === 1 || searchText === undefined
            ? ''
            : searchText.toLowerCase()
          : '' || searchText !== ''
            ? searchText.toLowerCase()
            : '',
    };
    onChange(filters);
  };

  const customSort = (column, sortDirection) => {
    if (column) {
      setOrderBy(column.sortField);
      setDirection(sortDirection);
    }
  };

  const handlePerRowsChange = async (recordPerPage) => {
    if (perPage !== recordPerPage) {
      setPerPages(recordPerPage);
      setPageSize(recordPerPage);
    }
  };

  const handlePageChange = (page) => {
    if (currentPage !== page) {
      setCurrentPage(page);
    }

    const pagination = document.getElementById('pagination-first-page');
    if (page === 1 && pagination !== null) {
      pagination.click();
    }
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'Records per page',
  };

  const emptyStateProps = {
    isLoading: isLoading,
  };

  return (
    <div className="data-table pt-0">
      <DataTable
        columns={tableColumns}
        noDataComponent={<EmptyComponent {...emptyStateProps} />}
        data={items}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
        pagination
        onChangePage={handlePageChange}
        paginationServer={true}
        paginationComponentOptions={paginationComponentOptions}
        subHeader={subHeader}
        onSort={customSort}
        sortServer
        paginationTotalRows={totalRows}
        // subHeaderComponent={subHeaderComponentMemo}
        onChangeRowsPerPage={handlePerRowsChange}
        sortIcon={renderSortIcons(direction)}
        {...rest}
      />
    </div>
  );
};

ReactDataTable.propTypes = {
  columns: PropTypes.array,
  paginationRowsPerPageOptions: PropTypes.array,
  defaultLimit: PropTypes.number,
  totalRows: PropTypes.number,
  onChange: PropTypes.func,
  sortAction: PropTypes.func,
};
export default ReactDataTable;
